import { get, post } from 'api/client';
import env from 'config';
import dayjs from 'dayjs';
import {
  InAppNotification,
  InAppNotificationFilter,
  InAppNotificationsSummary,
  InAppNotificationTab,
  NotificationCount,
} from 'types/InAppNotification';
import utc from 'dayjs/plugin/utc';
import { getExtendedTimeout } from 'utils/request';

dayjs.extend(utc);

export type InAppNotificationsQueryParams = {
  tab?: InAppNotificationTab;
  filter?: InAppNotificationFilter;
};

const InAppNotificationsApi = {
  getUnseenCount: (): Promise<NotificationCount> => {
    return get('me/notifications/count', {
      baseURL: env.API_SERVICE_ENDPOINT,
      timeout: getExtendedTimeout(),
    });
  },
  getSummary: (): Promise<InAppNotificationsSummary> => {
    return get('me/notifications/summary', {
      baseURL: env.API_SERVICE_ENDPOINT,
    });
  },
  get: (
    params: InAppNotificationsQueryParams & { page: number },
  ): Promise<InAppNotification[]> => {
    return get('me/notifications', {
      baseURL: env.API_SERVICE_ENDPOINT,
      params,
    });
  },
  markAllAsRead: (): Promise<{ status: boolean }> => {
    return post(
      'me/notifications/mark-all-as-read',
      {
        until: dayjs().utc().unix(),
      },
      {
        baseURL: env.API_SERVICE_ENDPOINT,
      },
    );
  },
  markAsRead: (id: string): Promise<{ status: boolean }> => {
    return post(`notifications/${id}/mark-as-read`, null, {
      baseURL: env.API_SERVICE_ENDPOINT,
    });
  },
  markAllAsSeen: (): Promise<{ status: boolean }> => {
    return post(
      'me/notifications/mark-all-as-seen',
      {
        until: dayjs().utc().unix(),
      },
      {
        baseURL: env.API_SERVICE_ENDPOINT,
      },
    );
  },
};

export default InAppNotificationsApi;
